export default "__VITE_ASSET__D$g43qCF__"